import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export const toasterVariants = cva(
  'fixed flex flex-col z-50 max-h-screen p-4 pointer-events-none w-[calc(100%-2rem)] sm:w-96',
  {
    variants: {
      position: {
        'top-left': 'top-0 left-0',
        'top-center': 'top-0 left-1/2 -translate-x-1/2',
        'top-right': 'top-0 right-0',
        'bottom-left': 'bottom-0 left-0',
        'bottom-center': 'bottom-0 left-1/2 -translate-x-1/2',
        'bottom-right': 'bottom-0 right-0',
      },
    },
  },
);

export type KaToasterVariants = VariantProps<typeof toasterVariants>;
export type KaToasterPosition = NonNullable<KaToasterVariants['position']>;
